module.exports = __webpack_public_path__ + "static/media/iconlocationlg.c73b09be.svg";